import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadMyProvingsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadMyProvingsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'dateTo' | 'dateFrom' | 'created'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    ), responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>, deputy: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )> }
  )>, principal: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'type' | 'upn' | 'name' | 'email' | 'roles'>
  )> }
);

export const ReadMyProvingsDocument = gql`
    query ReadMyProvings($search: String) {
  provings(filter: {title: {REGEX: $search}, status: {NIN: [8, 9, 10]}}) {
    _deleted
    id
    _id
    status
    title
    dateTo
    dateFrom
    created
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    deputy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    provingGround {
      _id
      title
      countryCode
    }
  }
  principal {
    _id
    type
    upn
    name
    email
    roles
  }
}
    `;

    export function useReadMyProvingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadMyProvingsQuery, ReadMyProvingsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadMyProvingsQuery, ReadMyProvingsQueryVariables>(ReadMyProvingsDocument, baseOptions);
    };
      export function useReadMyProvingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadMyProvingsQuery, ReadMyProvingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadMyProvingsQuery, ReadMyProvingsQueryVariables>(ReadMyProvingsDocument, baseOptions);
      };
      
export type ReadMyProvingsQueryHookResult = ReturnType<typeof useReadMyProvingsQuery>;
export type ReadMyProvingsQueryResult = ApolloReactCommon.QueryResult<ReadMyProvingsQuery, ReadMyProvingsQueryVariables>;